import { LoaderCircle, RefreshCw, X } from 'lucide-react'
import { Badge, ButtonIcon, cn, DefaultTooltip } from 'twyne-new.ui'

import { useAgent } from './context'

const STATUS = {
  pairing: { color: 'neutral', label: 'Pairing with Claude…', spinner: true },
  connected: { color: 'accent', label: 'Connected to Claude' },
  executing: { color: 'accent', label: 'Claude is editing…', spinner: true },
  reconnecting: { color: 'warning', label: 'Reconnecting to Claude…', spinner: true },
  error: { color: 'danger', label: 'Claude pairing failed' },
  disconnected: { color: 'neutral', label: 'Claude disconnected' },
}

const DOTS = {
  neutral: 'twy-bg-neutral',
  accent: 'twy-bg-accent',
  warning: 'twy-bg-warning',
  danger: 'twy-bg-danger',
}

const ACTIVE = ['pairing', 'connected', 'executing', 'reconnecting']

export default function AgentBadge() {
  const { status, error, lastCommand, pairing, disconnect, retry } = useAgent()
  const config = STATUS[status]

  if (!config) {
    return null
  }

  const details = [
    error,
    pairing?.pairingId ? `Pairing #${pairing.pairingId}` : null,
    lastCommand ? `Last command ${lastCommand.ok ? 'applied' : `failed: ${lastCommand.error || 'unknown error'}`}` : null,
  ].filter(Boolean).join(' · ')

  return <Badge color={config.color} variant='light' size='sm' className='h-8 px-2 gap-2'>
    {config.spinner ? <LoaderCircle className='animate-spin' size={14} /> : <span className={cn('size-2 rounded-full', DOTS[config.color])} />}
    <DefaultTooltip content={details || config.label} triggerProps={{ asChild: true }}>
      <span>{config.label}</span>
    </DefaultTooltip>
    {status === 'error' ? <ButtonIcon content='Retry pairing' onClick={retry}>
      <RefreshCw size={14} />
    </ButtonIcon> : null}
    {ACTIVE.includes(status) ? <ButtonIcon content='Disconnect Claude' onClick={disconnect}>
      <X size={14} />
    </ButtonIcon> : null}
  </Badge>
}
